import { render, staticRenderFns } from "./UrlToRole.vue?vue&type=template&id=419c70a4&"
import script from "./UrlToRole.vue?vue&type=script&lang=js&"
export * from "./UrlToRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports